import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useGeneralSellerPerformance(
  branch_id,
  start_date,
  end_date,
  revenue_mode = "total",
  enabled = true
) {
  const { getGeneralSellerPerformance } = useApi();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "general-seller-performance",
      branch_id,
      start_date,
      end_date,
      revenue_mode,
    ],
    queryFn: () =>
      getGeneralSellerPerformance({
        branch_id,
        start_date,
        end_date,
        revenue_mode,
      }),
    enabled: Boolean(enabled && branch_id && start_date && end_date),
    staleTime: 2 * 60 * 1000,
  });

  return {
    sellers: data?.data?.sellers ?? null,
    isLoading,
    isError,
    error,
  };
}
